import useWindowDimensions from "helpers/screen";
import CryptoIcon from "components/Secondary/CryptoIcon";
import "../../../TradePage/OpenOrdersBox/style.scss"
import "./style.scss";

const mock = [{
  name: "BTC-USDC",
  limit: 41103.42,
  amount: 0.3,
  value: 5306.23,
  action: "Close"
},
{
  name: "BTC-USDC",
  limit: 41103.42,
  amount: 0.3,
  value: 5306.23,
  action: "Close"
},
{
  name: "BTC-USDC",
  limit: 41103.42,
  amount: 0.3,
  value: 5306.23,
  action: "Close"
},
{
  name: "BTC-USDC",
  limit: 41103.42,
  amount: 0.3,
  value: 5306.23,
  action: "Close"
},
{
  name: "BTC-USDC",
  limit: 41103.42,
  amount: 0.3,
  value: 5306.23,
  action: "Close"
},]


const OpenOrdersTable = ({}) => {
  const {width} = useWindowDimensions();

  return <div className="openOrdersBox WalletPageOpenOrdersTable">
        {width > 900 &&
          <div className="sorter">
            <p>Name</p>
            <p>Limit Price</p>
            <p>Amount</p>
            <p>Value</p>
            <p className="action">Action</p>
          </div>
        }

        <div className="openOrdersTables mobileTable">
          {
            mock.map((item, i) => {
              return <div key={i} className="item">
                <div>
                  {width <= 900 && <p>Name</p>}
                  <div className="flex">
                    <CryptoIcon symbol="BTC" size={16}/>
                    <p className="tickerName">{item.name}</p>
                  </div>
                </div>

                <div>
                  {width <= 900 && <p>Limit Price</p>}
                  <p>{item.limit}</p>
                </div>

                <div>
                  {width <= 900 && <p>Amount</p>}
                  <p>{item.amount}</p>
                </div>

                <div>
                  {width <= 900 && <p>Value</p>}
                  <p>{item.value}</p>
                </div>

                <div>
                  {width <= 900 && <p>Action</p>}
                  <p className="closeButton">{item.action}</p>
                </div>
              </div>
            })
          }
          
        </div>
    </div>
}

export default OpenOrdersTable;